import { Column } from '@tanstack/react-table'
import { Checkbox } from './checkbox'
import { Popover, PopoverContent, PopoverTrigger } from './popover'
import { FilterIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ColumnFilterProps<TData, TValue> {
  column: Column<TData, TValue>
  options: Array<{ label: string; value: string }>
}

function ColumnFilter<TData, TValue>({
  column,
  options,
}: ColumnFilterProps<TData, TValue>) {
  const filterValue = (column.getFilterValue() as string[]) || []

  const handleFilterChange = (value: string, checked: boolean) => {
    if (checked) {
      column.setFilterValue([...filterValue, value])
    } else {
      column.setFilterValue(filterValue.filter((v) => v !== value))
    }
  }

  return (
    <Popover>
      <PopoverTrigger>
        <FilterIcon
          size={14}
          className={cn(
            filterValue.length > 0 ? 'text-primary' : 'text-muted-foreground',
          )}
        />
      </PopoverTrigger>
      <PopoverContent className='w-fit p-0' align='start'>
        <div className='p-4'>
          <div className='space-y-2'>
            {options.map((option) => (
              <div key={option.value} className='flex items-center space-x-2'>
                <Checkbox
                  id={option.value}
                  className='border-muted bg-accent'
                  checked={filterValue.includes(option.value)}
                  onCheckedChange={(checked) =>
                    handleFilterChange(option.value, !!checked)
                  }
                />
                <label
                  htmlFor={option.value}
                  className='text-sm cursor-pointer font-medium leading-none'
                >
                  {option.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}

export { ColumnFilter }
